export const APPOINTMENTS_OPEN_PARAM = 'appointments';
export const APPOINTMENTS_VIEW_PARAM = 'appointmentsView';
export const APPOINTMENT_DETAIL_PARAM = 'appointment';
export const VIRTUAL_APPOINTMENT_DETAIL_PARAM = 'va';

export type AppointmentsView = 'practice' | 'virtual';

const VIRTUAL_VIEW_VALUE: AppointmentsView = 'virtual';

// Every param the overlay owns, so closing it leaves no stale view or selection behind.
export const APPOINTMENTS_OVERLAY_PARAMS = [
    APPOINTMENTS_OPEN_PARAM,
    APPOINTMENTS_VIEW_PARAM,
    APPOINTMENT_DETAIL_PARAM,
    VIRTUAL_APPOINTMENT_DETAIL_PARAM
] as const;

export function parseAppointmentsView(raw: string | null): AppointmentsView {
    return raw === VIRTUAL_VIEW_VALUE ? 'virtual' : 'practice';
}

// Practice is the default view, so it is the absence of the param; each view's selection is dropped.
export function withAppointmentsView(
    params: URLSearchParams,
    view: AppointmentsView
): URLSearchParams {
    const next = new URLSearchParams(params);
    next.delete(APPOINTMENT_DETAIL_PARAM);
    next.delete(VIRTUAL_APPOINTMENT_DETAIL_PARAM);
    if (view === VIRTUAL_VIEW_VALUE) next.set(APPOINTMENTS_VIEW_PARAM, view);
    else next.delete(APPOINTMENTS_VIEW_PARAM);
    return next;
}
